import { createSlice } from '@reduxjs/toolkit'

export const orgSlice = createSlice({
  name: 'org-list',
  initialState: {
    orgList: [],
    orgListLoading: true,
    workerList: [],
    workerListLoading: true,
    workerListNeedUpdate: false,
    orgTagList: []
  },
  reducers: {
    updateOrgList: (state, { payload }) => {
      state.orgList = payload.orgList
    },
    setOrgListLoading: (state, { payload }) => {
      state.orgListLoading = payload.loading
    },
    updateOrgTagList: (state, { payload }) => {
      state.orgTagList = payload.tagList
    },
  }
})

export const {
  updateOrgList,
  setOrgListLoading,
  updateOrgTagList
} = orgSlice.actions

export default orgSlice.reducer
